import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../types'
import { CmsConverterService, defaultFSCatalog } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TilesConverter extends CmsConverterService<TilesData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      tiles: formData?.st_items ?? defaultFSCatalog,
      transparency: formData?.st_transparency?.value ?? false,
      iconVariant: formData?.st_icon_variant?.value ?? false,
    }
  }
}

export const TILES_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TilesData>>('TilesConverter')

export interface TilesData extends ConvertedComponentData {
  tiles: FsCatalog;
  transparency: boolean;
  iconVariant: boolean;
}
